module.exports = __webpack_public_path__ + "static/media/leftCrmIcons.2fbcc772.png";